/**
 * @module Options
 * @description Breakpoint settings
 */
export const MOBILE_BREAKPOINT = 768;

export const TABLET_BREAKPOINT = 1024;

export const DESKTOP_BREAKPOINT = 1280;
